import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {
    FL_DESCRIPTION,
    FL_TITLE,
} from "../../../components/i18n/formLabels";
import {
    PH_TITLE,
} from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";

const EventLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder},
            title: '',
            longDescription: '',
            sellingUrl: '',
            defaultImege: '',
            memoryImage: '',
            memoryDescription: '',
            preImage: '',
            preDescription: '',
            blogUrl: '',
            videoUrl: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"8"}>
                <FormGroup>
                    <Label>{'Imagen'}</Label>
                    <Input
                        type="text"
                        name="defaultImege"
                        value= { child.defaultImege }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"4"}>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        rows={8}
                        name="longDescription"
                        value= { child.longDescription }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"8"}>
                <FormGroup>
                    <Label>{'Imagen post-evento'}</Label>
                    <Input
                        type="text"
                        name="memoryImage"
                        value= { child.memoryImage }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"4"}>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{'Descripción post-evento'}</Label>
                    <Input
                        type="textarea"
                        rows={8}
                        name="memoryDescription"
                        value= { child.memoryDescription }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"8"}>
                <FormGroup>
                    <Label>{'Imagen pre-evento'}</Label>
                    <Input
                        type="text"
                        name="preImage"
                        value= { child.preImage }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"4"}>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{'Descripción pre-evento'}</Label>
                    <Input
                        type="textarea"
                        rows={8}
                        name="preDescription"
                        value= { child.preDescription }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"12"}>
                <FormGroup>
                    <Label>{'URL de Blog'}</Label>
                    <Input
                        type="text"
                        name="blogUrl"
                        value= { child.blogUrl }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{'URL de venta'}</Label>
                    <Input
                        type="text"
                        name="sellingUrl"
                        value= { child.sellingUrl }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{'URL de video'}</Label>
                    <Input
                        type="text"
                        name="videoUrl"
                        value= { child.videoUrl }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>


        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default EventLangs
